import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { ViewState } from '../Root/viewModel'

import {
  ATTRIBUTE_INTEREST,
  ATTRVALUE_INTEREST_FLEET,
  ATTRVALUE_INTEREST_LOGBOOK,
  ATTRIBUTE_NUMBERCARS,
} from '../../utils/constants'

const INDEX_LOGBOOK_4CARS = 0
const INDEX_LOGBOOK_5PLUSCARS = 1
const INDEX_FLEET_CONTACTINFO = 2

export type Props = {
  state: ViewState
}

export type ViewModel = {
  numberOfCars?: number | null
  isValid: boolean

  handleNext: () => void
  handleBack: () => void
  handleFormValid: (boolean) => void
  handleFormChange: (Object) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    numberOfCars: null,
    isValid: false,

    handleNext: mobx.action(() => {
      state.customAttributes.set(ATTRIBUTE_NUMBERCARS, vm.numberOfCars)

      const values = transitioner.getValueCollection()
      const interest = values.attrs.get(ATTRIBUTE_INTEREST)
      let nextNode = null
      if (interest === ATTRVALUE_INTEREST_FLEET) {
        const nextNodeLink =
          state.currentNode &&
          state.currentNode.options &&
          state.currentNode.options[INDEX_FLEET_CONTACTINFO]
        nextNode = nextNodeLink && nextNodeLink.link
      } else if (interest === ATTRVALUE_INTEREST_LOGBOOK) {
        const nextNodeLinkIndex =
          vm.numberOfCars > 4 ? INDEX_LOGBOOK_5PLUSCARS : INDEX_LOGBOOK_4CARS
        const nextNodeLink =
          state.currentNode &&
          state.currentNode.options &&
          state.currentNode.options[nextNodeLinkIndex]
        nextNode = nextNodeLink && nextNodeLink.link
      }
      if (nextNode) transitioner.goForward(nextNode.id)
    }),
    handleBack: mobx.action(() => {
      state.customAttributes.delete(ATTRIBUTE_NUMBERCARS)
    }),
    handleFormValid: mobx.action((isValid) => {
      // @ts-expect-error@2322
      vm.isValid = isValid
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { numberOfCars } = values
      vm.numberOfCars = numberOfCars
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
